<template>
  <div>
    <div class="charge-finish-draw-gun v-service">
      <div class="unpaid">
        <div class="unpaid-tag">
          <img src="../../../assets/img/ic_unpaid.png">
          <div class="unpaid-tag-text">未支付订单</div>
        </div>
        <div class="unpaid-table-title">
          <div class="charge-fare-sum">

          </div>
          <!-- <div class="details-info"
               @click="gotoPriceInfo">
            电价信息
          </div> -->
        </div>
        <div class="unpaid-table-header">
          <div class="header-cell">
            订单号: {{orderNo}}
          </div>
        </div>
        <div class="unpaid-table-content">
          <div class="content-title">
            电费(元)
          </div>
          <div class="content-title">
            服务费(元)
          </div>
          <div class="content-title">
            充电(度)
          </div>
        </div>
        <div class="unpaid-table-content">
          <div class="content-cell">
            {{info.electAmount | formatNullValue}}
          </div>
          <div class="content-cell">
            {{info.serviceAmount | formatNullValue}}
          </div>
          <div class="content-cell">
            {{info.chargeElect | formatNullValue}}
          </div>
        </div>
        <div class="unpaid-table-content">
          <div class="content-title">
            延时费(元)
          </div>
          <div class="content-title">
            延时时长
          </div>
          <div class="content-title">
            充电时长
          </div>
        </div>
        <div class="unpaid-table-content">
          <div class="content-cell">
            {{info.delayAmount | formatNullValue}}
          </div>
          <div class="content-cell">
            {{info.delayMinutes | formatNullValue}}
          </div>
          <div class="content-cell">
            {{info.chargeMinutes | formatNullValue}}
          </div>
        </div>
        <div class="unpaid-table-content-line">
          <div class="content-title">
            停止原因
          </div>
          <div class="content-cell">
            {{info.stopReason | formatNullValue}}
          </div>
        </div>
        <div class="unpaid-table-content-line">
          <div class="content-title">
            车牌号
          </div>
          <div class="content-cell">
            {{info.carNo | formatNullValue}}
          </div>
        </div>
        <div class="unpaid-table-content-line">
          <div class="content-title">
            地址
          </div>
          <div class="content-cell">
            {{info.staAddress | formatNullValue}}
          </div>
        </div>
        <!-- <div class="unpaid-table-content-line" v-if="info.totalAmount != info.amountUnPaid">
          <div class="content-title">
            已支付
          </div>
          <div class="content-cell">
            {{(info.totalAmount-info.amountUnPaid) | formatNullValue}}元
          </div>
        </div>
        <div class="unpaid-table-content-line" v-if="info.totalAmount != info.amountUnPaid">
          <div class="content-title">
            待支付
          </div>
          <div class="content-cell" style="color: red">
            {{info.amountUnPaid | formatNullValue}}元
          </div>
        </div> -->
      </div>
      <div class="money">
        合计:
        <span class="value">{{info.totalAmount | formatNullValue}}元</span>
      </div>
       <!-- v-if="info.payType != 3" -->
      <div class="btn-box"
          >
        <pi-button block
                   type="primary"
                   :default="disablePay"
                   @click="doPay">支付</pi-button>
        <pi-button block
                   style="margin-top:0.4rem"
                   @click="gotoRecharge">充值</pi-button>
        <!-- <div class="button1" :class="{disable: disablePay}"  @click="doPay">
          支付
        </div>
        <div class="button2" @click="gotoRecharge">
          充值
        </div> -->
      </div>
      <!-- <div class="btn-box"
           v-else>
        <pi-button block
                   type="default">请等待管理员处理</pi-button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Button, RadioGroup, Radio, Cell, CellGroup } from "vant";
import { doPayOrder, getOrderFareInfo } from "../../../common/api/index";
export default {
  name: "change-success",
  components: {
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      radio: "1",
      drawGun: true, // 是否已拔枪
      disablePay: false, // 显示支付订单
      info: {},
      // accountPkId: null,
      // gunNumber: null,
      // serialNumber: null,
      orderNo: null,
      timer: null,
    };
  },
  props: {
    propOrderNo: {
      type: String,
      default: ''
    }
  },
  mounted() {
    // this.accountPkId = this.$route.query.accountPkId;
    // this.gunNumber = this.$route.query.gunNumber;
    // this.serialNumber = this.$route.query.serialNumber;
    this.orderNo = this.propOrderNo == '' ? this.$route.query.orderNo : this.propOrderNo;
    this.getOrderFareInfo();
    this.pollUpdate();
  },
  methods: {
    getOrderFareInfo() {
      getOrderFareInfo({
        orderNo: this.orderNo,
      })
        .then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            this.info = data.data[0];
            this.disablePay =
              this.info.accountBalanceAmount < this.info.totalAmount;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pollUpdate() {
      this.timer = setInterval(() => {
        this.refresh();
      }, this.$config.pullTimeDistance);
    },
    refresh() {
      this.getOrderFareInfo();
    },
    doPay() {
      if (this.disablePay) {
        this.$dialog
          .confirm({
            message:
              "余额不足，当前余额" +
              this.info.accountBalanceAmount +
              "元，还需充值" +
              (this.info.totalAmount - this.info.accountBalanceAmount).toFixed(
                2
              ) +
              "元，请充值!",
            confirmButtonText: "充值",
            confirmButtonColor: "#14CC80",
            closeOnPopstate: true,
          })
          .then(() => {
            // on confirm
            this.$router.push({
              name: "recharge",
            });
          })
          .catch(() => {});
        return;
      }

      doPayOrder({
        orderNo: this.orderNo,
      })
        .then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            this.$router.replace({
              name: "pay-success",
              query: {
                orderNo: this.orderNo,
                replace: true
              },
              params: { payResult: true },
            });
          } else {
            this.$router.replace({
              name: "pay-success",
              query: {
                orderNo: this.orderNo,
                replace: true
              },
              params: { payResult: false },
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toast(error.message);
        });
    },
    gotoRecharge() {
      this.$router.push("/recharge");
    },
    gotoPriceInfo() {
      if (!this.info.orderNo) {
        return;
      }
      this.$router.push({
        name: "charging/success/price",
        query: { orderNo: this.info.orderNo },
      });
    },
  },
  beforeDestroy() {
    console.log("charge-wait-pay beforeDestroy");
    clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
@primaryColor: #14cc80;
.divider {
  border-bottom: #d9d9d9 1px solid;
  margin: 0 0.2rem;
}
.charge-finish-draw-gun {
  .charge-finish-tag {
    font-size: 0.36rem;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    padding: 0.72rem 0;
  }
}
.cell {
  position: relative;
  padding: 0.24rem 0.24rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .cell-title {
    color: #999999;
    min-width: 2rem;
  }
  .cell-content {
    color: #666666;
    flex: 1;
    width: 0;
    text-align: end;
  }
  &:after {
    position: absolute;
    left: 0.2rem;
    right: 0.2rem;
    bottom: 0;
    border-bottom: 1px solid #d9d9d9;
    opacity: 0.8;
    content: "";
  }
}

.info {
  margin: 0 0.36rem;
  .info-name {
    color: #666666;
  }
  .info-content {
    background-color: #f8f4f5;
    display: flex;
    .info-content-container {
      flex: 1;
      padding: 0.11rem;
      .tag {
        color: #666666;
        text-align: center;
      }
      .value {
        color: #999999;
        margin-top: 0.14rem;
        text-align: center;
      }
    }
  }
}
.unpaid {
  .unpaid-tag {
    padding: 0.37rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 0.56rem;
      height: 0.56rem;
      font-size: 0.58rem;
    }
    .unpaid-tag-text {
      margin: 0 0.2rem;
      font-size: 0.42rem;
      color: @primaryColor;
    }
  }
  .unpaid-table-title {
    display: flex;
    justify-content: space-between;
    margin: 0.23rem 0.45rem;
    .charge-fare-sum {
      color: #999999;
      font-size: 0.28rem;
    }
    .details-info {
      color: #ff8f1f;
      font-size: 0.26rem;
    }
  }
  .unpaid-table-header {
    background-color: rgba(20, 204, 128, 0.14);
    display: flex;
    margin: 0.23rem 0.24rem 0 0.24rem;
    .header-cell {
      color: #666666;
      font-size: 0.24rem;
      flex: 1;
      border-right: white 0.02rem solid;
      padding: 0.02rem 0.2rem;
      line-height: 0.4rem;
    }
  }
  .unpaid-table-content {
    background-color: #f8f4f5;
    display: flex;
    margin: 0 0.24rem 0.02rem 0.24rem;
    .content-title {
      color: #666666;
      font-size: 0.26rem;
      flex: 1;
      text-align: center;
      border-right: white 0.02rem solid;
      padding: 0.11rem 0;
    }
    .content-cell {
      color: #333333;
      font-size: 0.28rem;
      flex: 1;
      text-align: center;
      border-right: white 0.02rem solid;
      padding: 0.11rem 0;
    }
  }
  .unpaid-table-content-line {
    background-color: #f8f4f5;
    display: flex;
    margin: 0 0.24rem 0.02rem 0.24rem;
    justify-content: space-between;
    .content-title {
      color: #666666;
      font-size: 0.28rem;
      padding: 0.11rem 0.2rem;
      width: 1.5rem;
    }
    .content-cell {
      color: #333333;
      font-size: 0.28rem;
      padding: 0.11rem 0.2rem;
    }
  }
}
.money {
  text-align: right;
  font-size: 0.28rem;
  color: #333333;
  font-weight: 500;
  padding: 0.2rem 0.2rem 0 0;
  span {
    font-size: 0.42rem;
    color: @primaryColor;
  }
}
.btn-box {
  margin: 0.4rem;
}
</style>
